/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState, useEffect } from "react";
// react plugin used to create charts
import { Line, Pie } from "react-chartjs-2";
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
} from "reactstrap";
// core components
import {
  dashboardEmailStatisticsChart,
  dashboardNASDAQChart,
} from "variables/charts.js";
import axios from "axios";
import { API_SMART } from "utils";
import swal from "sweetalert";

function Dashboard() {
  const [kunHariIni, setKunHariIni] = useState(0);
  const [kunMingguIni, setKunMingguIni] = useState(0);
  const [kunBulanIni, setKunBulanIni] = useState(0);
  const [kunMingguLalu, setKunMingguLalu] = useState(0);
  const [dataRound, setDataRound] = useState();
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);

  const [data3, setData3] = useState([]);
  const [data4, setData4] = useState([]);
  const [dataUsers6Bulan, setDataUsers6Bulan] = useState([]);
  const [labels6Bulan, setLabels6Bulan] = useState([]);
  const [dataAktivitas7Hari, setDataAktivitas7Hari] = useState([]);
  const [labels7Hari, setLabels7Hari] = useState([]);

  async function loadingData() {
    try {
      const r1 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `SELECT  dateTime
        FROM logapp
        WHERE  DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate() `,
      });
      setKunHariIni(r1.data.data);
      const r2 = await axios.get(API_SMART + `kunjunganMingguIni`);
      setKunMingguIni(r2.data.data);
      const r3 = await axios.get(API_SMART + `kunjunganBulanIni`);
      setKunBulanIni(r3.data.data);
      const r4 = await axios.get(API_SMART + `kunjunganMingguLalu`);
      setKunMingguLalu(r4.data.data);
    } catch (error) {
      swal("Failed!", "Forbiden", "error");
    }
  }
  async function loadingChartRound() {
    try {
      const r1 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `SELECT  dateTime
        FROM logapp
        WHERE  DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate() AND idUser="" `,
      });

      const r2 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `SELECT  dateTime
        FROM logapp
        WHERE  DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate() AND idUser<>"" `,
      });

      setDataRound([r1.data.data, r2.data.data]);
    } catch (error) {
      swal("Failed!", "Forbiden", "error");
    }
  }

  async function loadingChart() {
    try {
      const r1 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `SELECT  dateTime
        FROM logapp
        WHERE  DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate() AND page = "Home" `,
      });

      const r2 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `SELECT  dateTime
        FROM logapp
        WHERE  DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate() AND page = "Berita" `,
      });

      const r3 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `SELECT  dateTime
        FROM logapp
        WHERE  DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate() AND page = "DaftarHadir" `,
      });

      const r4 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `SELECT  dateTime
        FROM logapp
        WHERE  DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate() AND page = "Forum RSS" `,
      });

      const r5 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `SELECT  dateTime
        FROM logapp
        WHERE DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate() AND page = "Pasar UMKM" `,
      });

      const r6 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `SELECT  dateTime
        FROM logapp
        WHERE DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate() AND page = "Pasar Ternak" `,
      });

      const r7 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `SELECT  dateTime
        FROM logapp
        WHERE DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate() AND page = "BeritaDetail" `,
      });

      const dd = [
        r1.data.data,
        r2.data.data,
        r3.data.data,
        r4.data.data,
        r5.data.data,
        r6.data.data,
        r7.data.data,
      ];

      setData(dd);
    } catch (error) {
      swal("Failed!", "Forbiden", "error");
    }
  }
  async function loadingChart2() {
    try {
      const r1 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `SELECT  dateTime
        FROM logapp
        WHERE  DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate()-1 AND page = "Home" `,
      });

      const r2 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `SELECT  dateTime
        FROM logapp
        WHERE  DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate()-1 AND page = "Berita" `,
      });

      const r3 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `SELECT  dateTime
        FROM logapp
        WHERE  DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate()-1 AND page = "DaftarHadir" `,
      });

      const r4 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `SELECT  dateTime
        FROM logapp
        WHERE  DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate()-1 AND page = "Forum RSS" `,
      });

      const r5 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `SELECT  dateTime
        FROM logapp
        WHERE  DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) =curdate()-1 AND page = "Pasar UMKM" `,
      });

      const r6 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `SELECT  dateTime
        FROM logapp
        WHERE  DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate()-1 AND page = "Pasar Ternak" `,
      });

      const r7 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `SELECT  dateTime
        FROM logapp
        WHERE  DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate()-1 AND page = "BeritaDetail" `,
      });

      const dd = [
        r1.data.data,
        r2.data.data,
        r3.data.data,
        r4.data.data,
        r5.data.data,
        r6.data.data,
        r7.data.data,
      ];

      setData2(dd);
    } catch (error) {
      swal("Failed!", "Forbiden", "error");
    }
  }

  async function loadingChart3() {
    try {
      const r1 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `SELECT  dateTime
        FROM logapp
        WHERE  DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) =curdate()-2 AND page = "Home" `,
      });

      const r2 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `SELECT  dateTime
        FROM logapp
        WHERE  DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate()-2 AND page = "Berita" `,
      });

      const r3 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `SELECT  dateTime
        FROM logapp
        WHERE  DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate()-2 AND page = "DaftarHadir" `,
      });

      const r4 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `SELECT  dateTime
        FROM logapp
        WHERE  DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate()-2 AND page = "Forum RSS" `,
      });

      const r5 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `SELECT  dateTime
        FROM logapp
        WHERE  DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate()-2 AND page = "Pasar UMKM" `,
      });

      const r6 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `SELECT  dateTime
        FROM logapp
        WHERE  DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate()-2 AND page = "Pasar Ternak" `,
      });

      const r7 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `SELECT  dateTime
        FROM logapp
        WHERE  DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate()-2 AND page = "BeritaDetail" `,
      });

      const dd = [
        r1.data.data,
        r2.data.data,
        r3.data.data,
        r4.data.data,
        r5.data.data,
        r6.data.data,
        r7.data.data,
      ];

      setData3(dd);
    } catch (error) {
      swal("Failed!", "Forbiden", "error");
    }
  }

  async function loadingChart4() {
    try {
      const r1 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `select idUser, COUNT (*) AS jumlah_orang
        FROM logapp
        WHERE  DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate() AND page = "Home"
        GROUP BY idUser`,
      });

      const r2 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `select idUser, COUNT (*) AS jumlah_orang
        FROM logapp
        WHERE  DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate() AND page = "Berita"
        GROUP BY idUser`,
      });

      const r3 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `select idUser, COUNT (*) AS jumlah_orang
        FROM logapp
        WHERE  DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate() AND page = "DaftarHadir"
        GROUP BY idUser`,
      });

      const r4 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `select idUser, COUNT (*) AS jumlah_orang
        FROM logapp
        WHERE  DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate() AND page = "Forum RSS"
        GROUP BY idUser`,
      });

      const r5 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `select idUser, COUNT (*) AS jumlah_orang
        FROM logapp
        WHERE  DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate() AND page = "Pasar UMKM"
        GROUP BY idUser`,
      });

      const r6 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `select idUser, COUNT (*) AS jumlah_orang
        FROM logapp
        WHERE  DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate() AND page = "Pasar Ternak"
        GROUP BY idUser`,
      });

      const r7 = await axios.post(API_SMART + `kunjunganPerPage`, {
        sql: `select idUser, COUNT (*) AS jumlah_orang
        FROM logapp
        WHERE  DATE(CONVERT_TZ(dateTime, '+00:00', '+08:00')) = curdate() AND page = "BeritaDetail"
        GROUP BY idUser`,
      });

      const dd = [
        r1.data.data,
        r2.data.data,
        r3.data.data,
        r4.data.data,
        r5.data.data,
        r6.data.data,
        r7.data.data,
      ];

      setData4(dd);
    } catch (error) {
      swal("Failed!", "Forbiden", "error");
    }
  }

  // Generate data dummy untuk 1 tahun terakhir (per tiga bulanan/quarterly)
  function generateDataUsers6Bulan() {
    const quarters = [];
    const data = [];
    const currentDate = new Date();

    // Generate label quarter (4 quarter terakhir - 1 tahun)
    // Q1: Jan-Mar, Q2: Apr-Jun, Q3: Jul-Sep, Q4: Okt-Des
    const currentMonth = currentDate.getMonth(); // 0-11
    const currentQuarter = Math.floor(currentMonth / 3) + 1; // 1-4

    for (let i = 3; i >= 0; i--) {
      // Hitung quarter yang akan ditampilkan (mundur dari quarter saat ini)
      let targetQuarter = currentQuarter - i;
      let targetYear = currentDate.getFullYear();

      // Handle jika quarter negatif (tahun sebelumnya)
      while (targetQuarter <= 0) {
        targetQuarter += 4;
        targetYear -= 1;
      }

      // Tentukan nama quarter
      let quarterName = "";
      if (targetQuarter === 1) quarterName = "Q1 (Jan-Mar)";
      else if (targetQuarter === 2) quarterName = "Q2 (Apr-Jun)";
      else if (targetQuarter === 3) quarterName = "Q3 (Jul-Sep)";
      else quarterName = "Q4 (Okt-Des)";

      quarters.push(`${quarterName} ${targetYear}`);
    }

    // Generate data dengan pertumbuhan organik (compound growth)
    const startValue = 3442;
    const endValue = 6743;

    // Hitung compound growth rate per quarter
    const quarterIntervals = 3; // 3 interval untuk 4 quarter
    const growthRate = Math.pow(endValue / startValue, 1 / quarterIntervals);

    // Pertumbuhan per quarter yang tidak konstan (lebih organik)
    const growthRates = [
      1.12, // Q1 ke Q2: 12% growth
      1.18, // Q2 ke Q3: 18% growth (lebih cepat)
      1.1, // Q3 ke Q4: 10% growth (sedikit melambat)
    ];

    for (let i = 0; i < 4; i++) {
      if (i === 0) {
        // Quarter pertama selalu 3442
        data.push(startValue);
      } else if (i === 3) {
        // Quarter terakhir selalu 6743
        data.push(endValue);
      } else {
        // Pertumbuhan tidak konstan dengan variasi yang lebih besar
        const previousValue = data[i - 1];
        const baseGrowth = growthRates[i - 1];

        // Tambahkan variasi pada growth rate (±15%)
        const growthVariation = (Math.random() - 0.5) * 0.15;
        const adjustedGrowth = baseGrowth + growthVariation;

        // Hitung nilai baru dengan pertumbuhan yang bervariasi
        let newValue = Math.round(previousValue * adjustedGrowth);

        // Tambahkan variasi tambahan untuk lebih organik (±5% dari nilai baru)
        const valueVariation = (Math.random() - 0.5) * (newValue * 0.05);
        newValue = Math.round(newValue + valueVariation);

        // Pastikan nilai selalu meningkat minimal 50 dari quarter sebelumnya
        newValue = Math.max(previousValue + 50, newValue);

        data.push(newValue);
      }
    }

    setLabels6Bulan(quarters);
    setDataUsers6Bulan(data);
  }

  // Generate data aktivitas 7 hari terakhir
  function generateDataAktivitas7Hari() {
    const days = [];
    const data = [];
    const currentDate = new Date();
    const totalUsers = 6743; // Total users bulan terakhir
    const aktivitasRate = 0.6; // 60% aktivitas

    // Generate label hari dan data aktivitas (dari 7 hari lalu sampai kemarin)
    // Urutkan dari yang paling lama (i=7) ke yang terbaru (i=1)
    for (let i = 7; i >= 1; i--) {
      const date = new Date(currentDate);
      date.setDate(date.getDate() - i);
      const dayNames = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jumat",
        "Sabtu",
      ];
      const dayName = dayNames[date.getDay()];
      const dayNumber = date.getDate();
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Agu",
        "Sep",
        "Okt",
        "Nov",
        "Des",
      ];
      const monthName = monthNames[date.getMonth()];
      days.push(`${dayName}, ${dayNumber} ${monthName}`);

      // Generate data aktivitas: 20% untuk hari Minggu, 40% untuk hari Sabtu, 60% untuk hari lainnya
      if (dayName === "Minggu") {
        // Hari Minggu: aktivitas hanya 20%
        const mingguAktivitasRate = 0.2;
        const baseAktivitas = totalUsers * mingguAktivitasRate;
        const variation =
          Math.floor(Math.random() * (totalUsers * 0.05)) - totalUsers * 0.025;
        const aktivitas = Math.round(baseAktivitas + variation);
        data.push(Math.max(0, aktivitas));
      } else if (dayName === "Sabtu") {
        // Hari Sabtu: aktivitas 40%
        const sabtuAktivitasRate = 0.4;
        const baseAktivitas = totalUsers * sabtuAktivitasRate;
        const variation =
          Math.floor(Math.random() * (totalUsers * 0.08)) - totalUsers * 0.04;
        const aktivitas = Math.round(baseAktivitas + variation);
        data.push(Math.max(0, aktivitas));
      } else {
        // Hari lainnya: aktivitas 60% dengan variasi
        const baseAktivitas = totalUsers * aktivitasRate;
        const variation =
          Math.floor(Math.random() * (totalUsers * 0.1)) - totalUsers * 0.05;
        const aktivitas = Math.round(baseAktivitas + variation);
        data.push(Math.max(0, aktivitas));
      }
    }

    setLabels7Hari(days);
    setDataAktivitas7Hari(data);
  }

  // Generate data dummy untuk pie chart (account vs non account)
  function generateDataRound() {
    const totalUsers = 6743;
    // Asumsikan 40% non account, 60% account
    const nonAccount = Math.round(totalUsers * 0.4);
    const account = totalUsers - nonAccount;
    setDataRound([nonAccount, account]);
  }

  // Generate data dummy untuk kunjungan per page (hari ini, kemarin, kemarin dulu)
  function generateDataKunjunganPerPage() {
    const totalUsers = 6743;
    const aktivitasHarian = Math.round(totalUsers * 0.6); // 60% aktivitas harian

    // Distribusi kunjungan per page sesuai urutan labels: Home, Berita, DaftarHadir, Forum RSS, Pasar UMKM, Pasar Ternak, BeritaDetail
    const distribusiPage = [0.35, 0.25, 0.1, 0.08, 0.05, 0.02, 0.15];

    // Generate data untuk hari ini
    const dataHariIni = [];
    for (let i = 0; i < distribusiPage.length; i++) {
      const baseKunjungan = Math.round(aktivitasHarian * distribusiPage[i]);
      const variation =
        Math.floor(Math.random() * (baseKunjungan * 0.2)) - baseKunjungan * 0.1;
      dataHariIni.push(Math.max(0, baseKunjungan + variation));
    }
    // Tambahkan data untuk 3 item baru: Bayar PBB (~11), ESA Office (~1123), PPID (~123)
    dataHariIni.push(Math.round(11 + (Math.random() * 4 - 2))); // Bayar PBB: 9-13
    dataHariIni.push(Math.round(1123 + (Math.random() * 200 - 100))); // ESA Office: 1023-1223
    dataHariIni.push(Math.round(123 + (Math.random() * 20 - 10))); // PPID: 113-133

    // Generate data untuk kemarin (sedikit lebih rendah)
    const aktivitasKemarin = Math.round(aktivitasHarian * 0.95); // 95% dari hari ini
    const dataKemarin = [];
    for (let i = 0; i < distribusiPage.length; i++) {
      const baseKunjungan = Math.round(aktivitasKemarin * distribusiPage[i]);
      const variation =
        Math.floor(Math.random() * (baseKunjungan * 0.2)) - baseKunjungan * 0.1;
      dataKemarin.push(Math.max(0, baseKunjungan + variation));
    }
    // Tambahkan data untuk 3 item baru dengan sedikit variasi
    dataKemarin.push(Math.round(11 * 0.95 + (Math.random() * 4 - 2))); // Bayar PBB
    dataKemarin.push(Math.round(1123 * 0.95 + (Math.random() * 200 - 100))); // ESA Office
    dataKemarin.push(Math.round(123 * 0.95 + (Math.random() * 20 - 10))); // PPID

    // Generate data untuk kemarin dulu (sedikit lebih rendah lagi)
    const aktivitasKemarinDulu = Math.round(aktivitasHarian * 0.9); // 90% dari hari ini
    const dataKemarinDulu = [];
    for (let i = 0; i < distribusiPage.length; i++) {
      const baseKunjungan = Math.round(
        aktivitasKemarinDulu * distribusiPage[i]
      );
      const variation =
        Math.floor(Math.random() * (baseKunjungan * 0.2)) - baseKunjungan * 0.1;
      dataKemarinDulu.push(Math.max(0, baseKunjungan + variation));
    }
    // Tambahkan data untuk 3 item baru dengan sedikit variasi
    dataKemarinDulu.push(Math.round(11 * 0.9 + (Math.random() * 4 - 2))); // Bayar PBB
    dataKemarinDulu.push(Math.round(1123 * 0.9 + (Math.random() * 200 - 100))); // ESA Office
    dataKemarinDulu.push(Math.round(123 * 0.9 + (Math.random() * 20 - 10))); // PPID

    setData(dataHariIni);
    setData2(dataKemarin);
    setData3(dataKemarinDulu);
  }

  // Generate data dummy untuk users per page
  function generateDataUsersPerPage() {
    const totalUsers = 6743;
    const aktivitasHarian = Math.round(totalUsers * 0.6); // 60% aktivitas harian

    // Distribusi users per page sesuai urutan labels: Home, Berita, DaftarHadir, Forum RSS, Pasar UMKM, Pasar Ternak, BeritaDetail
    const distribusiPage = [0.35, 0.25, 0.1, 0.08, 0.05, 0.02, 0.15];

    const dataUsers = [];
    for (let i = 0; i < distribusiPage.length; i++) {
      // Users biasanya lebih sedikit dari kunjungan (satu user bisa multiple kunjungan)
      const baseUsers = Math.round(aktivitasHarian * distribusiPage[i] * 0.7); // 70% dari kunjungan
      const variation =
        Math.floor(Math.random() * (baseUsers * 0.15)) - baseUsers * 0.075;
      dataUsers.push(Math.max(0, baseUsers + variation));
    }
    // Tambahkan data users untuk 3 item baru (users biasanya lebih sedikit dari kunjungan)
    dataUsers.push(Math.round(11 * 0.7 + (Math.random() * 2 - 1))); // Bayar PBB: ~8
    dataUsers.push(Math.round(1123 * 0.7 + (Math.random() * 100 - 50))); // ESA Office: ~786
    dataUsers.push(Math.round(123 * 0.7 + (Math.random() * 10 - 5))); // PPID: ~86

    setData4(dataUsers);
  }

  // Generate data dummy untuk 4 card statistik
  function generateDataCardStats() {
    const totalUsers = 6743;
    const aktivitasHarian = Math.round(totalUsers * 0.6); // 60% aktivitas harian
    const aktivitasSabtu = Math.round(totalUsers * 0.4); // 40% aktivitas Sabtu
    const aktivitasMinggu = Math.round(totalUsers * 0.2); // 20% aktivitas Minggu

    // Hari ini: aktivitas harian dengan variasi kecil
    const hariIni = aktivitasHarian + Math.floor(Math.random() * 200 - 100);
    setKunHariIni(Math.max(0, hariIni));

    // Minggu ini: 7 hari (5 hari kerja @60%, 1 Sabtu @40%, 1 Minggu @20%)
    const hariKerja = 5;
    const mingguIni =
      hariKerja * aktivitasHarian +
      aktivitasSabtu +
      aktivitasMinggu +
      Math.floor(Math.random() * 500 - 250);
    setKunMingguIni(Math.max(0, mingguIni));

    // Bulan ini: ~30 hari (rata-rata 22 hari kerja @60%, 4 Sabtu @40%, 4 Minggu @20%)
    const hariKerjaBulan = 22;
    const sabtuBulan = 4;
    const mingguBulan = 4;
    const bulanIni =
      hariKerjaBulan * aktivitasHarian +
      sabtuBulan * aktivitasSabtu +
      mingguBulan * aktivitasMinggu +
      Math.floor(Math.random() * 2000 - 1000);
    setKunBulanIni(Math.max(0, bulanIni));

    // Minggu lalu: sedikit lebih rendah dari minggu ini (95%)
    const mingguLalu =
      Math.round(mingguIni * 0.95) + Math.floor(Math.random() * 300 - 150);
    setKunMingguLalu(Math.max(0, mingguLalu));
  }

  useEffect(() => {
    // Generate data dummy untuk semua grafik
    generateDataCardStats();
    generateDataUsers6Bulan();
    generateDataAktivitas7Hari();
    generateDataRound();
    generateDataKunjunganPerPage();
    generateDataUsersPerPage();

    // Data dari API di-comment untuk menggunakan data dummy
    // loadingData();
    // loadingChart();
    // loadingChart2();
    // loadingChart3();
    // loadingChart4();
    // loadingChartRound();
  }, []);

  const dashboardEmailStatisticsChart = {
    data: (canvas) => {
      return {
        labels: ["non acount", "acount"],
        datasets: [
          {
            label: "Akses dengan account vs non account",
            pointRadius: 0,
            pointHoverRadius: 0,
            backgroundColor: ["#e3e3e3", "#4acccd", "#fcc468", "#ef8157"],
            borderWidth: 0,
            data: dataRound,
          },
        ],
      };
    },
    options: {
      plugins: {
        legend: { display: false },
        tooltip: { enabled: true },
      },
      maintainAspectRatio: true,
      pieceLabel: {
        render: "percentage",
        fontColor: ["white"],
        precision: 2,
      },
      scales: {
        y: {
          ticks: {
            display: false,
          },
          grid: {
            drawBorder: false,
            display: false,
          },
        },
        x: {
          barPercentage: 1.6,
          grid: {
            drawBorder: false,
            display: false,
          },
          ticks: {
            display: false,
          },
        },
      },
    },
  };
  const dashboard24HoursPerformanceChart = {
    data: (canvas) => {
      return {
        labels: [
          "Home",
          "Berita",
          "DaftarHadir",
          "Forum RSS",
          "Pasar UMKM",
          "Pasar Ternak",
          "BeritaDetail",
          "Bayar PBB",
          "ESA Office",
          "PPID",
        ],
        datasets: [
          {
            label: "hari ini",
            borderColor: "#6bd098",
            backgroundColor: "#6bd098",

            borderWidth: 3,
            tension: 0.4,
            pointBorderColor: "#6bd098",
            pointRadius: 4,
            pointHoverRadius: 4,
            pointBorderWidth: 8,
            data: data,
          },
          {
            label: "Kemarin",
            borderColor: "#f17e5d",
            backgroundColor: "#f17e5d",
            pointBorderColor: "#f17e5d",
            pointRadius: 4,
            pointHoverRadius: 4,
            pointBorderWidth: 8,
            borderWidth: 3,
            tension: 0.4,

            data: data2,
          },
          {
            label: "Kemarin dulu",
            borderColor: "#4acccd",
            backgroundColor: "#4acccd",
            pointBorderColor: "#4acccd",
            pointRadius: 4,
            pointHoverRadius: 4,
            pointBorderWidth: 8,
            borderWidth: 3,
            tension: 0.4,

            data: data3,
          },
        ],
      };
    },
    options: {
      plugins: {
        legend: { display: true },
        tooltip: { enabled: true },
      },
      scales: {
        y: {
          ticks: {
            color: "#9f9f9f",
            beginAtZero: false,
            maxTicksLimit: 5,
          },
          grid: {
            drawBorder: false,
            display: false,
          },
        },
        x: {
          barPercentage: 1.6,
          grid: {
            drawBorder: false,
            display: false,
          },
          ticks: {
            padding: 20,
            color: "#9f9f9f",
          },
        },
      },
    },
  };

  const dashboardNASDAQChart = {
    data: (canvas) => {
      return {
        labels: [
          "Home",
          "Berita",
          "DaftarHadir",
          "Forum RSS",
          "Pasar UMKM",
          "Pasar Ternak",
          "BeritaDetail",
          "Bayar PBB",
          "ESA Office",
          "PPID",
        ],
        datasets: [
          {
            data: data,
            label: "kunjungan",
            fill: false,
            borderColor: "#4acccd",
            backgroundColor: "#4acccd",
            pointBorderColor: "#4acccd",
            pointRadius: 4,
            pointHoverRadius: 4,
            pointBorderWidth: 8,
            tension: 0.4,
          },
          {
            data: data4,
            label: "user",
            fill: false,
            borderColor: "#e3e3e3",
            backgroundColor: "transparent",
            pointBorderColor: "#e3e3e3",
            pointRadius: 4,
            pointHoverRadius: 4,
            pointBorderWidth: 8,
            tension: 0.4,
          },
        ],
      };
    },
    options: {
      plugins: {
        legend: { display: false },
      },
    },
  };

  // Chart pertambahan users 6 bulan terakhir
  const dashboardUsers6BulanChart = {
    data: (canvas) => {
      return {
        labels: labels6Bulan,
        datasets: [
          {
            label: "Total Users",
            data: dataUsers6Bulan,
            fill: true,
            borderColor: "#51bcda",
            backgroundColor: "rgba(81, 188, 218, 0.1)",
            pointBorderColor: "#51bcda",
            pointBackgroundColor: "#51bcda",
            pointRadius: 5,
            pointHoverRadius: 7,
            pointBorderWidth: 2,
            tension: 0.4,
          },
        ],
      };
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true,
          position: "top",
        },
        tooltip: {
          enabled: true,
          callbacks: {
            label: function (context) {
              return `Users: ${context.parsed.y.toLocaleString("id-ID")}`;
            },
          },
        },
      },
      scales: {
        y: {
          beginAtZero: false,
          ticks: {
            color: "#9f9f9f",
            callback: function (value) {
              return value.toLocaleString("id-ID");
            },
          },
          grid: {
            drawBorder: false,
            color: "rgba(159, 159, 159, 0.1)",
          },
        },
        x: {
          ticks: {
            color: "#9f9f9f",
          },
          grid: {
            drawBorder: false,
            display: false,
          },
        },
      },
    },
  };

  // Chart aktivitas pengguna 7 hari terakhir
  const dashboardAktivitas7HariChart = {
    data: (canvas) => {
      return {
        labels: labels7Hari,
        datasets: [
          {
            label: "Pengguna Aktif",
            data: dataAktivitas7Hari,
            fill: true,
            borderColor: "#f17e5d",
            backgroundColor: "rgba(241, 126, 93, 0.2)",
            pointBorderColor: "#f17e5d",
            pointBackgroundColor: "#f17e5d",
            pointRadius: 5,
            pointHoverRadius: 7,
            pointBorderWidth: 2,
            tension: 0.4,
            barPercentage: 0.6,
          },
        ],
      };
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true,
          position: "top",
        },
        tooltip: {
          enabled: true,
          callbacks: {
            label: function (context) {
              const totalUsers = 6743;
              const percentage = (
                (context.parsed.y / totalUsers) *
                100
              ).toFixed(1);
              return `Aktif: ${context.parsed.y.toLocaleString(
                "id-ID"
              )} (${percentage}%)`;
            },
          },
        },
      },
      scales: {
        y: {
          beginAtZero: true,
          ticks: {
            color: "#9f9f9f",
            callback: function (value) {
              return value.toLocaleString("id-ID");
            },
          },
          grid: {
            drawBorder: false,
            color: "rgba(159, 159, 159, 0.1)",
          },
        },
        x: {
          ticks: {
            color: "#9f9f9f",
            maxRotation: 45,
            minRotation: 45,
          },
          grid: {
            drawBorder: false,
            display: false,
          },
        },
      },
    },
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col lg="3" md="6" sm="6">
            <Card className="card-stats">
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-single-02 text-warning" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Hari ini</p>
                      <CardTitle tag="p">{kunHariIni}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
                <div className="stats">
                  <i className="fas fa-sync-alt" /> kunjungan
                </div>
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card className="card-stats">
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-single-02 text-success" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Minggu ini</p>
                      <CardTitle tag="p">{kunMingguIni}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
                <div className="stats">
                  <i className="far fa-calendar" /> kunjungan
                </div>
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card className="card-stats">
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-single-02 text-danger" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Bulan Ini</p>
                      <CardTitle tag="p">{kunBulanIni}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
                <div className="stats">
                  <i className="far fa-clock" /> kunjungan
                </div>
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card className="card-stats">
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-single-02 text-primary" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Minggu Lalu</p>
                      <CardTitle tag="p">{kunMingguLalu}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
                <div className="stats">
                  <i className="fas fa-sync-alt" /> kunjungan
                </div>
              </CardFooter>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h5">Pertambahan Users</CardTitle>
                <p className="card-category">
                  1 Tahun Terakhir (Per Tiga Bulanan)
                </p>
              </CardHeader>
              <CardBody style={{ height: "400px" }}>
                <Line
                  data={dashboardUsers6BulanChart.data}
                  options={dashboardUsers6BulanChart.options}
                  width={400}
                  height={400}
                />
              </CardBody>
              <CardFooter>
                <hr />
                <div className="stats">
                  <i className="fa fa-users" /> Pertumbuhan dari{" "}
                  {dataUsers6Bulan[0]?.toLocaleString("id-ID")} ke{" "}
                  {dataUsers6Bulan[3]?.toLocaleString("id-ID")} users
                </div>
              </CardFooter>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h5">Aktivitas Pengguna</CardTitle>
                <p className="card-category">7 Hari Terakhir</p>
              </CardHeader>
              <CardBody style={{ height: "400px" }}>
                <Line
                  data={dashboardAktivitas7HariChart.data}
                  options={dashboardAktivitas7HariChart.options}
                  width={400}
                  height={400}
                />
              </CardBody>
              <CardFooter>
                <hr />
                <div className="stats">
                  <i className="fa fa-chart-line" /> Rata-rata aktivitas ~60%
                  dari total users
                </div>
              </CardFooter>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h5">Kunjungan User</CardTitle>
                <p className="card-category">Today's performance</p>
              </CardHeader>
              <CardBody>
                <Line
                  data={dashboard24HoursPerformanceChart.data}
                  options={dashboard24HoursPerformanceChart.options}
                  width={400}
                  height={100}
                />
              </CardBody>
              <CardFooter>
                <hr />
                <div className="stats">
                  <i className="fa fa-history" /> refresh to Updated
                </div>
              </CardFooter>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md="4">
            <Card>
              <CardHeader>
                <CardTitle tag="h5">Akses Statistics</CardTitle>
                <p className="card-category">akses dengan account vs non</p>
              </CardHeader>
              <CardBody style={{ height: "266px" }}>
                <Pie
                  data={dashboardEmailStatisticsChart.data}
                  options={dashboardEmailStatisticsChart.options}
                />
              </CardBody>
              <CardFooter>
                <div className="legend">
                  <i className="fa fa-circle text-primary" /> acount{" "}
                  <i className="fa fa-circle text-gray" /> non acount
                </div>
                <hr />
                <div className="stats">
                  <i className="fa fa-calendar" /> total akses
                </div>
              </CardFooter>
            </Card>
          </Col>
          <Col md="8">
            <Card className="card-chart">
              <CardHeader>
                <CardTitle tag="h5">KUNJUNGAN HARI INI</CardTitle>
                <p className="card-category">Kunjungan vs Users</p>
              </CardHeader>
              <CardBody>
                <Line
                  data={dashboardNASDAQChart.data}
                  options={dashboardNASDAQChart.options}
                  width={400}
                  height={100}
                />
              </CardBody>
              <CardFooter>
                <div className="chart-legend">
                  <i className="fa fa-circle text-warning" /> kunjungan
                </div>
                <div className="chart-legend">
                  <i className="fa fa-circle text-warning" /> users
                </div>
                <hr />
                <div className="card-stats">
                  <i className="fa fa-check" /> Data information certified
                </div>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Dashboard;
